import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAction, firebaseMutations } from 'vuexfire'

import db from "./db"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flags: [], // Will be bound as an array
    user: null // Will be bound as an object
  },
  mutations: {
    // your mutations
    ...firebaseMutations
  },
  actions: {
    bindRef: firebaseAction(({ bindFirebaseRef }, { name, ref }) => {
      bindFirebaseRef(name, ref)
    }),
    init: firebaseAction(({ bindFirebaseRef }) => {
      bindFirebaseRef('flags', db.collection('flags'))
      bindFirebaseRef('lowRes', db.collection('low-res-images'))
    })
  }
})
